import React, { HTMLAttributes } from "react";
import { CardStatusLocation } from "./types";
import { useCardStatusProps } from "./useCardStatusProps";
import { BasicColor } from "../../types";

export type CardStatusProps = HTMLAttributes<HTMLDivElement> & {
  location: CardStatusLocation;
  color: BasicColor;
};

export const CardStatus = (props: CardStatusProps) => {
  const rest = useCardStatusProps(props);
  return <div {...rest} />;
};

export default CardStatus;
